/* eslint-disable */

import React from "react";
import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import {
  fetchAccountNotesPost,
  fetchUserTimeline,
  fetchUserGet,
  fetchGraphQL,
} from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";

import ModelComponentAccountPlan from "../../../ui-components/model-component-account-plan/model-component-account-plan.tsx";

import ModelComponentPaymentMethod from "../../../ui-components/model-component-payment-method/model-component-payment-method";
import ModelComponentUserPII from "../../../ui-components/model-component-user-pii/model-component-user-pii.tsx";
import ModelComponentUserStatus from "../../../ui-components/model-component-user-status/model-component-user-status.tsx";
import ModelComponentUser from "../../../ui-components/model-component-user/model-component-user.tsx";
import ModelComponentAccount from "../../../ui-components/model-component-account/model-component-account.tsx";

import NimbusTimelineItem from "../../../ui-components/nimbus-timeline-item/nimbus-timeline-item";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import UserLogo from "../../../ui-components/user-logo/user-logo";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";

import RaindropDivider from "../../../ui-components/raindrop-divider/raindrop-divider.js";

import ModelFilter from "../../../ui-components/model-filter/model-filter.tsx";

const UserTimelineFilter = ({ ignoreTypes, toggleType }) => {
  return (
    <div className="flex flex-row gap-2 p-2 flex-wrap">
      <ModelFilter
        type="USER_STATUS"
        isHidden={ignoreTypes.includes("USER_STATUS")}
        onClick={() => toggleType("USER_STATUS")}
      />

      <ModelFilter
        type="ACCOUNT_PLAN_EXECUTION"
        isHidden={ignoreTypes.includes("ACCOUNT_PLAN_EXECUTION")}
        onClick={() => toggleType("ACCOUNT_PLAN_EXECUTION")}
      />
      <ModelFilter
        type="ACCOUNT_PLAN"
        isHidden={ignoreTypes.includes("ACCOUNT_PLAN")}
        onClick={() => toggleType("ACCOUNT_PLAN")}
      />
      <ModelFilter
        type="PAYMENT_METHOD"
        isHidden={ignoreTypes.includes("PAYMENT_METHOD")}
        onClick={() => toggleType("PAYMENT_METHOD")}
      />

      <ModelFilter
        type="USER_PII"
        isHidden={ignoreTypes.includes("USER_PII")}
        onClick={() => toggleType("USER_PII")}
      />

      <ModelFilter
        type="NOTE"
        isHidden={ignoreTypes.includes("NOTE")}
        onClick={() => toggleType("NOTE")}
      />
    </div>
  );
};

const UserTimeline = ({ userId }) => {
  const [timeline, setTimeline] = useState(null);
  const [ignoreTypes, setIgnoreTypes] = useState(["ACCOUNT_PLAN"]);

  useEffect(() => {
    fetchUserTimeline({
      userId: userId,
    })
      .then((timeline) => {
        setTimeline(timeline);
      })
      .catch((e) => {
        console.log("🟢 (RD-301) - ", e);
      });
  }, [userId]);

  const UserTimelineTitle = () => {
    return (
      <div className="flex flex-col gap-3 w-full max-w-md">
        <div className="flex flex-row gap-3 font-bold text-3xl items-center">
          Timeline
        </div>
      </div>
    );
  };

  const toggleType = (type) => {
    if (ignoreTypes.includes(type)) {
      setIgnoreTypes(ignoreTypes.filter((t) => t !== type));
    } else {
      setIgnoreTypes([...ignoreTypes, type]);
    }
  };

  let previousDate = null;
  return (
    <div className={`flex flex-col h-full gap-2 overflow-scroll w-full`}>
      <UserTimelineTitle />
      <UserTimelineFilter ignoreTypes={ignoreTypes} toggleType={toggleType} />
      <RaindropScrollContainer>
        {timeline &&
          timeline.items
            .filter((item) => !ignoreTypes.includes(item.type))
            .map((timelineItem) => {
              const oldPreviousDate = previousDate;
              previousDate = timelineItem.date;
              return (
                <NimbusTimelineItem
                  type={timelineItem.type}
                  data={timelineItem.data}
                  date={timelineItem.date}
                  datePrevious={oldPreviousDate}
                />
              );
            })}
      </RaindropScrollContainer>
    </div>
  );
};

const UserActionPanel = ({ accountId }) => {
  const [showNoteEditor, setShowNoteEditor] = useState(false);
  const [noteText, setNoteText] = useState("This is a note for the user");

  const onCreateNote = () => {
    fetchAccountNotesPost({
      accountId: accountId,
      text: noteText,
    });
  };

  return (
    <div className="flex flex-col py-4 gap-4">
      <div>
        <RaindropButton
          title="Create note"
          icon="fa-notes-medical"
          style={ButtonStyle.Secondary}
          onClick={() => setShowNoteEditor(!showNoteEditor)}
        />
      </div>
      {showNoteEditor && (
        <div className="flex flex-col gap-2 w-full bg-color-dark-background-secondary p-4 rounded-lg">
          <RaindropInput
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            icon=""
          />
          <RaindropButton
            title="Create"
            icon="fa-plus"
            style={ButtonStyle.Secondary}
            onClick={onCreateNote}
          />
        </div>
      )}
    </div>
  );
};

const UserIsSupportingRaindrop = ({ isSupportingRaindrop }) => {
  if (!isSupportingRaindrop) {
    return <div>Not supporting </div>;
  }
  return <div>User is supporting raindrop</div>;
};

const NimbusUsersInstance = () => {
  const { userId } = useParams();

  const [user, setUser] = useState(null); // deprecated - move to account
  const [account, setAccount] = useState(null);

  const [retryCount, setRetryCount] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserGet({ userId })
      .then((user) => {
        setUser(user);
      })
      .catch((e) => {
        setError(e);
      });
  }, [userId, retryCount]);

  const UserTitle = () => {
    return (
      <div className="flex flex-col w-full py-4">
        <div className="flex flex-row gap-4 items-center">
          <UserLogo src={""} isLarge={true} />
          <div className="flex flex-col">
            <div className="font-bold text-4xl">
              {user.latest_pii.name_legal}
            </div>
            <div className="text-color-dark-text-secondary">
              Member since September 2024
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!user) return;

    fetchGraphQL(`
      query {
        account(id: "${user.account.id}") {
          isRaindropPlus 
        }
      }
    `).then((response) => {
      console.log("Account response", response);
      if (response.data.account) {
        setAccount(response.data.account);
      }
    });
  }, [user]);

  if (user === null || account === null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className="flex flex-row justify-around h-full w-full ">
      <div className="flex flex-col w-full max-w-lg h-full py-6">
        <UserTitle />
        <UserActionPanel accountId={user.account?.id} />
        <UserIsSupportingRaindrop
          isSupportingRaindrop={account.isRaindropPlus}
        />
        <RaindropScrollContainer>
          <ModelComponentUser userId={user?.id} src={""} />
          <ModelComponentUserStatus
            userStatusId={user.latest_status?.id}
            statusTitle={user.latest_status?.status}
          />
          <ModelComponentUserPII
            userId={user.id}
            userPIIId={user.latest_pii?.id}
            nameLegal={user.latest_pii.name_legal}
            namePreferred={user.latest_pii.name_preferred}
            userEmail={user.latest_pii.email}
          />
          <ModelComponentAccount
            accountId={user.account.id}
            createdAt={user.account.created_at}
            paymentProviderIdentifierStripe={
              user.account.payment_provider_identifier_stripe
            }
            paymentMethodIdentifierStripe={
              user.account.payment_method_identifier_stripe
            }
            rawData={user.account}
          />
          {user.account.active_plan && (
            <ModelComponentAccountPlan
              id={user.account.active_plan.id}
              subunits={user.account.active_plan.subunits}
              subunitsCurrency={user.account.active_plan.subunits_currency}
              sausages={user.account.active_plan.sausages}
              contributionDay={user.account.active_plan.contribution_day}
              rawData={user.account.active_plan}
            />
          )}
          {user.account.payment_method_active && (
            <ModelComponentPaymentMethod
              paymentMethodId={user.account.payment_method_active.id}
              createdAt={user.account.payment_method_active.created_at}
              paymentMethodIdentifierStripe={
                user.account.payment_method_active.payment_provider_identifier
              }
              paymentMethodIdentifierGoCardless={
                user.account.payment_method_active
                  .payment_method_identifier_gocardless
              }
            />
          )}
        </RaindropScrollContainer>
      </div>
      <RaindropDivider isVertical={true} />
      <div className="max-w-lg h-full py-6">
        <UserTimeline userId={userId} />
      </div>
    </div>
  );
};

export default NimbusUsersInstance;
